export const convertTimestamp = (timestamp: number): string => {
  const date = new Date(timestamp);

  const options: Intl.DateTimeFormatOptions = {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  };

  const formattedDate = date.toLocaleDateString('en-US', options);

  const day = date.getDate();
  let daySuffix = 'th';

  if (day % 10 === 1 && day !== 11) {
    daySuffix = 'st';
  } else if (day % 10 === 2 && day !== 12) {
    daySuffix = 'nd';
  } else if (day % 10 === 3 && day !== 13) {
    daySuffix = 'rd';
  }

  return formattedDate.replace(`${day}`, `${day}${daySuffix}`).replace(',', '');
};

export const formatDateToUS = (dateString: string): string => {
  if (!dateString) {
    return '';
  }
  const [year, month, day] = dateString.split('-');

  return `${month}/${day}/${year}`;
};

export const formatToISODate = (date: string | Date): string => {
  const parsedDate = new Date(date);

  const year = parsedDate.getFullYear();
  const month = String(parsedDate.getMonth() + 1).padStart(2, '0');
  const day = String(parsedDate.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
};

/**
 * Converts a date string in ISO 8601 format (e.g., '2024-08-29T20:51:21.000+0000')
 * to 'MM/DD/YYYY' format.
 *
 * @param dateStr - The date string in ISO 8601 format
 * @returns The formatted date string in 'MM/DD/YYYY' format
 */
export const formatToMMDDYYYY = (dateStr: string): string => {
  const date = new Date(dateStr);
  const month = (date.getUTCMonth() + 1).toString().padStart(2, '0');
  const day = date.getUTCDate().toString().padStart(2, '0');
  const year = date.getUTCFullYear().toString();

  return `${month}/${day}/${year}`;
};

/**
 * Checks if a given date is over 365 days old.
 * @param date - The date string to check
 * @returns boolean - True if the date is over 365 days ago, otherwise false
 */
export const isDateOver365DaysOld = (createdDate: string): boolean => {
  const millisecondsInSecond = 1000;
  const secondsInMinute = 60;
  const minutesInHour = 60;
  const hoursInDay = 24;

  const createdDateObj = new Date(createdDate);
  const currentDate = new Date();

  const diffInDays =
    (currentDate.getTime() - createdDateObj.getTime()) /
    (millisecondsInSecond * secondsInMinute * minutesInHour * hoursInDay);

  return diffInDays > 365;
};
